import AOS from 'aos';

/**
 * @returns {jQuery}
 */
function getBackendComponents() {
    let components = null;

    try {
        components = window.pageeditor.loadedComponents;
    } catch {
        components = $();
    }

    return components;
}

$(document).ready(function(){
    $.merge(getBackendComponents().find('.init-singleitem--slider'), $('.init-singleitem--slider')).slick({
        dots: true,
        arrows: true,
        autoplay: true,
        infinite: true,
        rows: 0, //fixes bug with unexpected nested div (https://github.com/kenwheeler/slick/issues/3110)
        responsive: [
            {
                breakpoint: 1400,
                settings: {
                    arrows: false
                }
            }
        ],
        prevArrow: "<button class=\"slick-prev\"><svg id=\"Ebene_1\" data-name=\"Ebene 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"72.06\" height=\"236.97\" viewBox=\"0 0 72.06 236.97\">\n" +
            "  <title>pfeil_links</title>\n" +
            "  <polygon points=\"0.09 117.36 0 117.4 63.65 236.97 68.06 234.62 5.69 117.45 72.06 2.5 67.73 0 0 117.31 0.09 117.36\"/>\n" +
            "</svg>\n</button>",
        nextArrow: "<button class=\"slick-next\"><svg id=\"Ebene_1\" data-name=\"Ebene 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"25.42mm\" height=\"83.61mm\" viewBox=\"0 0 72.07 237.01\">\n" +
            "  <title>pfeil</title>\n" +
            "  <polygon points=\"72.07 117.33 4.33 0 0 2.5 66.38 117.47 4 234.66 8.41 237.01 72.07 117.42 71.98 117.38 72.07 117.33\"/>\n" +
            "</svg>\n</button>"
    });

    $.merge(getBackendComponents().find('.init-4col-slider'), $('.init-4col-slider')).slick({
        dots: false,
        arrows: true,
        autoplay: false,
        slidesToShow: 4,
        infinite: true,
        slidesToScroll: 1,
        rows: 0, //fixes bug with unexpected nested div (https://github.com/kenwheeler/slick/issues/3110)
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    //swipe: true,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    //swipe: true,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    //swipe: true,
                }
            }
            ,
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    dots: true,
                    arrows: false
                }
            }
        ],
        prevArrow: "<button class=\"slick-custom-prev\"><svg id=\"Ebene_1\" data-name=\"Ebene 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"72.06\" height=\"236.97\" viewBox=\"0 0 72.06 236.97\">\n" +
            "  <title>pfeil_links</title>\n" +
            "  <polygon points=\"0.09 117.36 0 117.4 63.65 236.97 68.06 234.62 5.69 117.45 72.06 2.5 67.73 0 0 117.31 0.09 117.36\"/>\n" +
            "</svg>\n</button>",
        nextArrow: "<button class=\"slick-custom-next\"><svg id=\"Ebene_1\" data-name=\"Ebene 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"25.42mm\" height=\"83.61mm\" viewBox=\"0 0 72.07 237.01\">\n" +
            "  <title>pfeil</title>\n" +
            "  <polygon points=\"72.07 117.33 4.33 0 0 2.5 66.38 117.47 4 234.66 8.41 237.01 72.07 117.42 71.98 117.38 72.07 117.33\"/>\n" +
            "</svg>\n</button>"
    });

    $.merge(getBackendComponents().find('.init-2col-slider'), $('.init-2col-slider')).slick({
        dots: false,
        arrows: true,
        autoplay: false,
        slidesToShow: 2,
        infinite: true,
        slidesToScroll: 1,
        rows: 0, //fixes bug with unexpected nested div (https://github.com/kenwheeler/slick/issues/3110)
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    arrows: false,
                    dots: true
                }
            }
        ],
        prevArrow: "<button class=\"slick-custom-prev\"><svg id=\"Ebene_1\" data-name=\"Ebene 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"72.06\" height=\"236.97\" viewBox=\"0 0 72.06 236.97\">\n" +
            "  <title>pfeil_links</title>\n" +
            "  <polygon points=\"0.09 117.36 0 117.4 63.65 236.97 68.06 234.62 5.69 117.45 72.06 2.5 67.73 0 0 117.31 0.09 117.36\"/>\n" +
            "</svg>\n</button>",
        nextArrow: "<button class=\"slick-custom-next\"><svg id=\"Ebene_1\" data-name=\"Ebene 1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"25.42mm\" height=\"83.61mm\" viewBox=\"0 0 72.07 237.01\">\n" +
            "  <title>pfeil</title>\n" +
            "  <polygon points=\"72.07 117.33 4.33 0 0 2.5 66.38 117.47 4 234.66 8.41 237.01 72.07 117.42 71.98 117.38 72.07 117.33\"/>\n" +
            "</svg>\n</button>"
    });

    $(".gallery-list__wrapper").magnificPopup({
        delegate: 'a',
        type: 'image',
        gallery:{
            enabled: true
        }
    });

    // Horizontale Navigation anpinnen
    var header = $('.elh-header');
    //var headerHeight = header.outerHeight();
    $(window).scroll(function(){
        var scrollPosToTop = $(this).scrollTop();
        if (scrollPosToTop > 10){
            header.addClass('mobile-fixed');
        }
        else {
            header.removeClass('mobile-fixed');
        }
        if (scrollPosToTop > 50){
            header.addClass('fixed');
        }
        else {
            header.removeClass('fixed');
        }
    });

    setTimeout(function(){
        AOS.init({
            duration: 800,
            once: true,
            offset: 50
        });
    },200);

});


